import React, {useState} from 'react';

type IProps = {
    item?: any;
}

const Accordion = (props: IProps) => {
    const [open, setOpen] = useState(false);
    let toggleHandler = () => {
        setOpen(!open);
    };

    return (
        <React.Fragment>
            <div className="accordion">
                <div className="accordion-item">
                    <div onClick={() => toggleHandler()} className="accordion-trigger">
                        <h4>{props.item.title}</h4>
                    </div>
                    <div className={`accordion-content ${open ? 'is-active' : ''}`}>
                        <p dangerouslySetInnerHTML={{__html: props.item.message}}></p>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
};

export default Accordion;
